import { createApi } from '@reduxjs/toolkit/query/react';
import { OfferDetail } from '../../types/jobOffer';
import { PaginationRequestType } from '../../types/pagination';
import { getBaseQuery, handleSessionExpiredError } from '../../utils/auth';
import { DraftOfferFiltersForm, GetOffersParams } from './types';

// Define a service using a base URL and expected endpoints
export const offerDraftApi = createApi({
  reducerPath: 'offerDraftApi',
  baseQuery: getBaseQuery('/offer-draft-flow'),
  endpoints: (builder) => ({
    // Offers
    getOffers: builder.query<
      PaginationRequestType<OfferDetail>,
      GetOffersParams
    >({
      query: (params) => ({
        url: '',
        params: {
          ...params,
          career: params?.careerId || undefined,
          campus: params?.campusId || undefined,
          workingDay: params?.workingDayId || undefined,
          name: params?.offerName || undefined,
        },
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    getFiltersForm: builder.query<DraftOfferFiltersForm, void>({
      query: () => '/form',
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetOffersQuery, useGetFiltersFormQuery } = offerDraftApi;
